import { useState } from 'react';
import { UnstyledButton, Menu, Image, Group, Badge } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons';
import images from './images';
import classes from './LanguagePicker.module.css';

const data = [
  { label: 'English', image: images.english },
  { label: 'French', image: images.french },
  { label: 'German', image: images.german },
  { label: 'Italian', image: images.italian },
  { label: 'Polish', image: images.polish },
];

export function LanguagePicker() {
  const [opened, setOpened] = useState(false);
  const [selected, setSelected] = useState(data[0]);
  const items = data.map((item) => (
    <Menu.Item
      leftSection={<Image src={item.image} width={18} height={18} />}
      onClick={() => setSelected(item)}
      key={item.label}
    >
      {item.label}
    </Menu.Item>
  ));

  return (
    <Menu
      onOpen={() => setOpened(true)}
      onClose={() => setOpened(false)}
      radius="md"
      width="target"
      withinPortal
    >
      <Menu.Target>
        <UnstyledButton className={classes.control} data-expanded={opened || undefined}>
          <Group spacing={"xs"} noWrap>
            <Image src={selected.image} width={22} height={22} />
            <span className={classes.label}>{selected.label}</span>
          </Group>
          <IconChevronDown size="1rem" className={classes.icon} stroke={1.5} />
          <Badge variant='filled' style={{textTransform: "capitalize"}} size='xs'>Beta</Badge>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>{items}</Menu.Dropdown>
    </Menu>
  );
}